import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { ConfirmationDialogComponent } from 'src/app/components/shared-components/confirmation-dialog/confirmation-dialog.component';
import { SnackBarService } from 'src/app/components/shared-components/snack-bar/snack-bar.service';
import { StaffsHelpbuttonService } from 'src/app/services/helpbutton-services/staffs-helpbutton-service/staffs-helpbutton.service';
import { UserStorageService } from 'src/app/services/user-storage-service/user-storage.service';

@Component({
  selector: 'app-helpbutton-staff-resume-card',
  templateUrl: './helpbutton-staff-resume-card.component.html',
  styleUrls: ['./helpbutton-staff-resume-card.component.scss']
})
export class HelpbuttonStaffResumeCardComponent implements OnInit, OnDestroy {

  @Input() staff;
  @Input() viewDisposition;
  centerList;
  deleteStaffSubscribe: Subscription;

  constructor(private userStorageService: UserStorageService,
              private staffsService: StaffsHelpbuttonService,
              private snackbarService: SnackBarService,
              private router: Router,
              public dialog: MatDialog) { }

  ngOnInit() {
    this.centerList = this.userStorageService.getCenterList();
  }

  public getCenter() {
    if (this.staff && this.centerList  && this.centerList.length > 0) {
      for (const center of this.centerList) {
        if (center.InternalId === this.staff.CenterInternalId) {
          return center.CenterName;
        }
      }
    } else {
      return 'not found';
    }
  }

  public gotoDetails(e) {
    if ((e.target.className !== 'mat-icon notranslate material-icons mat-icon-no-color') && (e.target.className !== 'mat-icon-button')) {
      this.router.navigate(['/helpbutton/staff', this.staff.InternalId]);
    }
  }

  public deleteStaff() {
    const dialogRef = this.dialog.open(ConfirmationDialogComponent, {
      data: {
        title: 'important',
        messages: ['helpbutton-page.delete staff', 'delete anyway']
      }
    });

    dialogRef.afterClosed().subscribe(action => {
      if (action) {
        this.deleteStaffSubscribe = this.staffsService.deleteStaff(this.staff.InternalId).subscribe(
          (res) => {
            if (res['data']['success']) {
              this.staffsService.refreshStaffs();
            } else {
              this.snackbarService.open('Cant be deleted', 'error');
            }
          },
          (error) => {
            this.snackbarService.open(error['error']['message'], 'error');
          }
        );
      }
    });
  }

  ngOnDestroy() {
    if (this.deleteStaffSubscribe) { this.deleteStaffSubscribe.unsubscribe(); }
  }

}
